import axios from 'axios';

var currentTarget;

function modalOpener() {
    $('.js-book-viewing').click(function(e) {
        e.preventDefault();

        let clicked = $(e.target);
        currentTarget = clicked.closest('.js-book-viewing');
        let remodal = getModal().remodal();

        remodal.open();
    })
}

function submissionHandler() {
    let form = $('#ne-bookviewing-modal form');

    form.submit((e) => {
        e.preventDefault();

        let values = form.serializeArray();
        let action = '/actions/groupfirst/api/deliver';
        let params = urlParams(values);
        let config = { headers: {'Content-Type': 'multipart/form-data' }};

        axios.post(action, params, config).then((response) => {
            if(response.data.status === 'success') {
                getModal().remodal().close();
            } else {
                let msg = '<p><strong> ' +
                            'Sorry, there was a problem. Please try again or contact support for assistance ' +
                          '</strong> </p>';
                form.prepend(msg);
            }
        })
    })
}

function urlParams(form) {
    let params = new FormData();

    Object.entries(form)
        .forEach((p) =>  {
            params.set(p[1].name, p[1].value);
        });

    params.set('source', 'Book a Viewing')

    return params;
}

function handleBookViewing() {
    modalOpener();
    submissionHandler();
}

function getModal() {
    return $('[data-remodal-id=ne-bookviewing-modal]');
}

export default handleBookViewing;
